import { usePreviewMode } from '../hooks/usePreviewMode';

/**
 * Toggle visible en el header — muestra al operador si está en modo preview
 * (genera barato + rápido pa iterar) o modo final (calidad alta).
 *
 * Visualmente:
 *  - OFF (default): badge gris "Final" — todas las generaciones a calidad/precio normal
 *  - ON: badge amarillo "🟡 Preview" — los agentes ajustan a low-cost (Live Avatar, 1K, etc.)
 */
export function PreviewModeToggle() {
  const { enabled, toggle } = usePreviewMode();

  return (
    <button
      onClick={toggle}
      title={
        enabled
          ? 'Modo preview ACTIVO — generaciones rápidas y baratas para iterar. Click para apagar.'
          : 'Modo preview apagado — generaciones a calidad/precio normal. Click para activar (ahorrá créditos al iterar).'
      }
      className={`px-2.5 py-1 rounded text-xs font-medium border transition-colors ${
        enabled
          ? 'bg-amber-500/20 text-amber-300 border-amber-500/50 hover:bg-amber-500/30'
          : 'bg-slate-800 text-slate-400 border-slate-700 hover:bg-slate-700'
      }`}
    >
      {enabled ? '🟡 Preview' : 'Final'}
    </button>
  );
}
